import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { gameTracking } from '../../../Utility/Tracking/FBLegacyTracking';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { setBoosterShuffle } from '../../Player/PlayerInventoryHelper';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import BaseBoosterBehavior from './BaseBoosterBehavior';

export default class ShuffleBoosterBehavior extends BaseBoosterBehavior {
    public play(state: IGameState): IGameState {
        // If there are not enough target cards, do nothing.
        if (!this.hasEnoughTargetCards(state)) return state;

        const targets = this.getTargetCards(state).map(cardID => ({
            cardID: cardID,
            oldValue: state.levelState.cardsState.cards[cardID].value,
            newValue: null,
        }));

        state = CardStateHelper.shuffleValueCards(state);

        targets.forEach(target => {
            target.newValue =
                state.levelState.cardsState.cards[target.cardID].value;
        });

        // Trigger shuffle animation task.
        state = CardStateHelper.setStateTaskData(state, {
            task: CardTask.SHUFFLE,
            cards: targets.map(t => t.cardID),
            targets: targets,
        });

        return this.consumeItemOrCoins(state);
    }

    public getTargetCards(state: IGameState): string[] {
        return CardStateHelper.getValueCards(state).filter(cardID => {
            const behavior = CardStateHelper.getCardBehavior(state, cardID);
            return behavior.isFaceUp(state) && !behavior.isObscured(state);
        });
    }

    public hasEnoughTargetCards(state: IGameState): boolean {
        // Must have at least two cards to swap.
        return this.getTargetCards(state).length > 1;
    }

    protected getPrice(state: IGameState): number {
        return state.levelState.boosterPrices.shuffle;
    }

    protected getInventoryItem(state: IGameState): number {
        return state.playerState.inventory.boosterShuffle;
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        gameTracking(FBTrackingEvent.TapOnShuffle);
        track('mChangerUsed', 1, TrackMethod.ADD);
        track('tChangerUsed', 1, TrackMethod.ADD);
        trackTransaction(
            state,
            TransactionType.INVENTORY,
            TActionType.BOOSTER_USE
        );

        return {
            ...state,
            playerState: setBoosterShuffle(
                state.playerState,
                state.playerState.inventory.boosterShuffle - 1,
                false
            ),
        };
    }

    protected spendCoins(state: IGameState): IGameState {
        state = super.spendCoins(state);

        gameTracking(FBTrackingEvent.TapOnShuffle);
        track('mChangerUsed', 1, TrackMethod.ADD);
        track('tChangerReceived', 1, TrackMethod.ADD);
        track('tChangerUsed', 1, TrackMethod.ADD);

        return state;
    }
}
